module.exports = __webpack_public_path__ + "media/PAG84-03.e3ea3538.mp3";